import PrintSetService from '@/services/bytepro/printSet.service';

export const printSet = {
  namespaced: true,
  state: {
    printSets: null,
    loading: false,
    error: null,
  },
  getters: {
    getPrintSets: (state) => state.printSets,
    isLoading: (state) => state.loading,
    hasError: (state) => state.error !== null,
    getError: (state) => state.error,
  },
  actions: {
    async get({ commit, state }) {
      // Return cached data if available
      if (state.printSets) {
        return Promise.resolve({ data: state.printSets, status: 200 });
      }

      commit('setLoading', true);
      commit('clearError');

      try {
        const resp = await PrintSetService.get();
        commit('setPrintSets', resp.data);
        commit('setLoading', false);
        commit('dummy', 'get - success');
        return Promise.resolve(resp);
      } catch (error) {
        commit('setError', error.response);
        commit('setLoading', false);
        commit('dummy', 'get - error');
        return Promise.reject(error.response);
      }
    },
    clearCache({ commit }) {
      commit('clearPrintSets');
    },
  },
  mutations: {
    setPrintSets(state, data) {
      state.printSets = data;
    },
    clearPrintSets(state) {
      state.printSets = null;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setError(state, error) {
      state.error = error;
    },
    clearError(state) {
      state.error = null;
    },
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
